export const APP_MARKETING_DOWNLOAD_LABEL = 'Download';

export const APP_MARKETING_HERO_CTA_LABEL = 'Get the app';

export const APP_MARKETING_TILE_VARIANT = {
    DEFAULT: 'Default',
    QR: 'QR'
} as const;

export const APP_MARKETING_CTA_LINK_TYPE = {
    DEFAULT: 'Default',
    OS_DOWNLOAD: 'Download based on OS'
} as const;

export const APP_MARKETING_DOWNLOAD_QUERY_PARAM = 'download';

export const APP_MARKETING_FEATURE_FLAGS = {
    SHOW_APP_MARKETING: 'show_app_marketing'
} as const;

export const APP_MARKETING_HERO_OFFER_IMAGE = {
    desktop: { width: 610, height: 170 },
    mobile: { width: 343, height: 98 }
} as const;
